module.exports = __webpack_public_path__ + "img/FI26447185.d42be3b7.png";